import { handleActions } from 'redux-actions';

import { indexOfId } from '../utils';
import { getData } from '../utils/request';
import { loadUpcomingShift } from './dashboard';
import { userRetrieved } from './auth';
import { initialShifts, initialFilteredParkinglots } from './book';
import {
  REMOVE_FROM_BOOKINGS,
  BOOKINGS_RETRIEVED,
  NEWSFEEDS_RETRIEVED,
  SHIFTS_RETRIEVED,
  PARKINGLOTS_RETRIEVED,
  UPDATE_LOCKBOX,
} from '../constants';

const initialState = {
  bookings: [],
  cars: [],
  newsfeeds: [],
  shifts: [],
  parkinglots: [],
  code: '',
};

/** ******************* ACTIONS ******************** */

export const bookingsRetrieved = bookings => ({
  type: [BOOKINGS_RETRIEVED],
  bookings,
});

const shiftsRetrieved = shifts => ({
  type: [SHIFTS_RETRIEVED],
  shifts,
});

const parkinglotsRetrieved = parkinglots => ({
  type: [PARKINGLOTS_RETRIEVED],
  parkinglots,
});

const newsfeedsRetrieved = newsfeeds => ({
  type: [NEWSFEEDS_RETRIEVED],
  newsfeeds,
});

const updateLockbox = code => ({
  type: [UPDATE_LOCKBOX],
  code,
});

export const clearLockbox = () => ({
  type: [UPDATE_LOCKBOX],
  code: '',
});

export const loadBookings = () => dispatch => {
  getData('bookings').then(response => {
    dispatch(bookingsRetrieved(response));
    dispatch(loadUpcomingShift(response));
  });
};

const loadShifts = () => dispatch =>
  getData('shifts').then(response => {
    dispatch(shiftsRetrieved(response));
    dispatch(initialShifts(response));
  });

const loadParkinglots = () => dispatch =>
  getData('parkinglots').then(response => {
    dispatch(initialFilteredParkinglots(response));
    dispatch(parkinglotsRetrieved(response));
  });

const loadNewsfeeds = () => dispatch => getData('newsfeeds').then(response => dispatch(newsfeedsRetrieved(response)));

export const loadUser = () => dispatch =>
  getData('users/status').then(response => {
    dispatch(userRetrieved(response));
  });

export const loadData = () => dispatch => {
  dispatch(loadUser());
  dispatch(loadBookings());
  dispatch(loadShifts());
  dispatch(loadParkinglots());
  dispatch(loadNewsfeeds());
};

export const loadLockbox = carId => dispatch => {
  getData(`lockboxes/${carId}`)
    .then(response => dispatch(updateLockbox(response.code)))
    .catch(e => console.log('Error!', e));
};

export const removeFromBookings = bookingId => ({
  type: [REMOVE_FROM_BOOKINGS],
  bookingId,
});

/** ******************* REDUCER ******************** */

export default handleActions(
  {
    [BOOKINGS_RETRIEVED]: (state, { bookings }) => ({
      ...state,
      bookings: bookings.map(b => ({
        startTime: b.start_time,
        endTime: b.end_time,
        vehicleClass: b.vehicle_class,
        ...b,
      })),
    }),

    [SHIFTS_RETRIEVED]: (state, { shifts }) => ({ ...state, shifts }),

    [PARKINGLOTS_RETRIEVED]: (state, { parkinglots }) => ({
      ...state,
      parkinglots,
    }),

    [NEWSFEEDS_RETRIEVED]: (state, { newsfeeds }) => ({
      ...state,
      newsfeeds,
    }),

    [REMOVE_FROM_BOOKINGS]: (state, { bookingId }) => {
      const id = indexOfId(state.bookings, bookingId);
      return {
        ...state,
        bookings: [...state.bookings.slice(0, id), ...state.bookings.slice(id + 1)],
      };
    },

    [UPDATE_LOCKBOX]: (state, { code }) => ({
      ...state,
      code,
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/redux/data.js